import { plans } from '../constants/plans'

export function getPerfilByLicence(licence) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou em getPerfilByLicence:', licence.licenca.toLocaleLowerCase()) }
  
  let userRules = []
  let userPermissions = []
  let userPlan = null
  if (licence.licenca.toLowerCase() === plans.planUser.title.toLocaleLowerCase()) {
    userRules = [plans.planUser.rule.id]
    userPermissions = plans.planUser.rule.permissions
    userPlan = plans.planUser
  } else if (licence.licenca.toLowerCase() === plans.planBroker.title.toLocaleLowerCase()) {
    userRules = [plans.planBroker.rule.id]
    userPermissions = plans.planBroker.rule.permissions
    userPlan = plans.planBroker
  } else if (licence.licenca.toLowerCase() === plans.planAdvanced.title.toLocaleLowerCase()) {
    userRules = [plans.planAdvanced.rule.id]
    userPermissions = plans.planAdvanced.rule.permissions
    userPlan = plans.planAdvanced
  } else if (licence.licenca.toLowerCase() === plans.planBusiness.title.toLocaleLowerCase()) {
    userRules = [plans.planBusiness.rule.id]
    userPermissions = plans.planBusiness.rule.permissions
    userPlan = plans.planBusiness
  } else if (licence.licenca.toLowerCase() === plans.planSingle.title.toLocaleLowerCase()) {
    userRules = [plans.planSingle.rule.id]
    userPermissions = plans.planSingle.rule.permissions
    userPlan = plans.planSingle
  } else if (licence.licenca.toLowerCase() === plans.planTeam.title.toLocaleLowerCase()) {
    userRules = [plans.planTeam.rule.id]
    userPermissions = plans.planTeam.rule.permissions
    userPlan = plans.planTeam
  } else {
    return null
  }
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('licenca:', licence.licenca.toLocaleLowerCase()) }
  return {
    userRules,
    userPermissions,
    userPlan
  }
}